module.exports = __webpack_public_path__ + "img/file-text.81a78e9b.svg";